import Alpine from "alpinejs";

// Focus
export const getFocusableElements = (el: HTMLElement): NodeListOf<Element> => {
	return el?.querySelectorAll(
		'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
	);
};

export const getFirstFocusable = (el: HTMLElement): HTMLElement | null => {
	return el?.querySelector(
		'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
	);
};

Alpine.magic("focusmain", () => {
	getFirstFocusable(document.querySelector("main"))?.focus();
});
